module.exports = __webpack_public_path__ + "img/Chemistry-t-17644-s002-474x318.022298bb.jpg";